var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibraryGridLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 48,
    viewBox: "0 0 58 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3C5 1.61929 6.11929 0.5 7.5 0.5H13.5C14.8807 0.5 16 1.61929 16 3C16 4.38071 14.8807 5.5 13.5 5.5H7.5C6.11929 5.5 5 4.38071 5 3Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3C17 1.61929 18.1193 0.5 19.5 0.5H25.5C26.8807 0.5 28 1.61929 28 3C28 4.38071 26.8807 5.5 25.5 5.5H19.5C18.1193 5.5 17 4.38071 17 3Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 3C29 1.61929 30.1193 0.5 31.5 0.5H37.5C38.8807 0.5 40 1.61929 40 3C40 4.38071 38.8807 5.5 37.5 5.5H31.5C30.1193 5.5 29 4.38071 29 3Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 3C41 1.61929 42.1193 0.5 43.5 0.5H49.5C50.8807 0.5 52 1.61929 52 3C52 4.38071 50.8807 5.5 49.5 5.5H43.5C42.1193 5.5 41 4.38071 41 3Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 11.5C40 10.3954 40.8954 9.5 42 9.5H56C57.1046 9.5 58 10.3954 58 11.5V25.5C58 26.6046 57.1046 27.5 56 27.5H42C40.8954 27.5 40 26.6046 40 25.5V11.5Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5C20 10.3954 20.8954 9.5 22 9.5H36C37.1046 9.5 38 10.3954 38 11.5V25.5C38 26.6046 37.1046 27.5 36 27.5H22C20.8954 27.5 20 26.6046 20 25.5V11.5Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5C0 10.3954 0.895431 9.5 2 9.5H16C17.1046 9.5 18 10.3954 18 11.5V25.5C18 26.6046 17.1046 27.5 16 27.5H2C0.89543 27.5 0 26.6046 0 25.5V11.5Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31.5C40 30.3954 40.8954 29.5 42 29.5H56C57.1046 29.5 58 30.3954 58 31.5V45.5C58 46.6046 57.1046 47.5 56 47.5H42C40.8954 47.5 40 46.6046 40 45.5V31.5Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31.5C20 30.3954 20.8954 29.5 22 29.5H36C37.1046 29.5 38 30.3954 38 31.5V45.5C38 46.6046 37.1046 47.5 36 47.5H22C20.8954 47.5 20 46.6046 20 45.5V31.5Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.5C0 30.3954 0.895431 29.5 2 29.5H16C17.1046 29.5 18 30.3954 18 31.5V45.5C18 46.6046 17.1046 47.5 16 47.5H2C0.89543 47.5 0 46.6046 0 45.5V31.5Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryGridLayout);
export default __webpack_public_path__ + "static/media/library-grid-layout.e7c0f96799b9452770841f21c79bf497.svg";
export { ForwardRef as ReactComponent };